import { Observable } from 'rxjs';

/**
 * Replacement for RxJS `interval()` whose ticks are driven by a
 * dedicated Web Worker instead of a main-thread `setInterval`. Worker timers
 * are not throttled in hidden/unfocused tabs, so the emissions keep their
 * cadence in the background.
 *
 * Each subscription owns one worker, which is terminated on teardown.
 */
export function workerInterval(periodMs: number): Observable<number> {
  return new Observable<number>((subscriber) => {
    const worker = new Worker(new URL('./heartbeat.worker', import.meta.url));
    let count = 0;
    worker.onmessage = (): void => subscriber.next(count++);
    worker.postMessage({ command: 'start', periodMs });
    return () => worker.terminate();
  });
}
